import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as React from "react"
import * as Common from "./common"
import { Row } from "./table-definition"
import Popup from "../../ppi/ppi-detail/utils/popup"

export default class AccountHeader extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            edit: false,
            value: props.row.amount,
            activeTab: this.isValueEditable() ? 'account' : 'comment',
            comment: props.row.comment,
            confirm: false,
            title: null,
            id: null
        }
    }

    render() {
        return <div
            className="scenario-account-header"
            title={this.props.row.title}>
            <span className="scenario-header-identifier">
                {this.props.row.account.number}
            </span>

            <span className="scenario-header-title">{this.props.row.title}</span>

            {this.renderCommentBadge()}
            {this.renderBadge()}

            <div className="scenario-editor">
                <button onClick={() => this.handleClickEdit()}>
                    <FontAwesomeIcon icon="edit" />
                </button>

                {this.renderPopup()}
            </div>
        </div>
    }

    // Le 66111 provient de la dette (simplifiée ou détaillée) : seul le commentaire est modifiable.
    private isValueEditable(): boolean {
        return this.props.row.account.number !== "66111"
    }

    private handleClickEdit(): void {
        this.setState({ edit: true })
    }

    private handleDelete(): void {
        this.props.onChange("account", {
            account: this.props.row.account,
            chapter: this.props.row.chapter,
            amount: null,
            comment: this.state.comment,
            isCommentEdited: false
        })
        this.setState({ edit: false, value: null })
    }

    private handleHidePopup(): void {
        this.setState({ edit: false })
    }

    private handleInputChange(e: React.ChangeEvent<HTMLInputElement>): void {
        const value = NaN !== e.target.valueAsNumber ? e.target.valueAsNumber : null
        this.setState({ value })
    }

    private handleSubmit(e: React.FormEvent<HTMLFormElement>): void {
        e.preventDefault()

        this.props.onChange("account", {
            account: this.props.row.account,
            chapter: this.props.row.chapter,
            amount: this.state.value,
            comment: this.state.comment,
            isCommentEdited: false
        })
        this.setState({ edit: false })
    }

    private renderBadge(): React.ReactNode {
        if (this.isValueEditable() && null != this.props.row.amount)
            return <span className="scenario-percentile">
                {this.props.row.amount}%
            </span>
    }

    private renderCommentBadge(): React.ReactNode {
        if (null != this.props.row.comment)
            return <span className="scenario-percentile" title={this.props.row.comment}>
                <FontAwesomeIcon icon="comment-alt" />
            </span>
    }

    private renderDeleteButton(): React.ReactNode {
        if (null != this.props.row.amount)
            return <button
                className="button is-secondary"
                onClick={() => this.handleDelete()}>
                Supprimer la valeur
            </button>
    }

    private rendeSaveCommentButton(): React.ReactNode {
        if (null != this.props.row.comment)
            return <button
                className="button is-primary"
                onClick={() => this.postComment()}>
                Mettre à jour
            </button>;
        else
            return <button
                className="button is-primary"
                onClick={() => this.postComment()}>
                Enregistrer
            </button>;
    }

    private renderDeleteCommentButton(): React.ReactNode {
        if (null != this.props.row.comment)
            return <button
                className="button is-secondary"
                onClick={() => this.deleteComment()}>
                Supprimer le commentaire
            </button>
    }

    private renderPopup(): React.ReactNode {
        if (this.state.edit)
            return <Popup
                onHide={() => this.handleHidePopup()}
                title={this.isValueEditable() ? "Pourcentage pour le compte" : "Commentaire du compte"}>
                <div className="edit-box-content">
                    <strong>{this.props.row.account.label}</strong>

                    <ul className="tabHeader">
                        {this.isValueEditable() &&
                            <li className={this.state.activeTab === 'account' ? 'active' : ''}
                                onClick={() => this.setState({ activeTab: 'account' })}>
                                Valeur
                            </li>}
                        <li className={this.state.activeTab === 'comment' ? 'active' : ''}
                            onClick={() => this.setState({ activeTab: 'comment' })}>
                            Commentaire
                        </li>
                    </ul>

                    <div className="tabsBody">
                        {this.isValueEditable() && this.state.activeTab === 'account' && <div className="tab1">
                            <span className="scenario-popup-description">
                                Vous allez modifier les pourcentages appliqués à l'ensemble du compte
                            </span>
                            <form onSubmit={e => this.handleSubmit(e)}>
                                <div className="columns is-desktop">
                                    <div className="column">
                                        <p className="field is-horizontal">
                                            <span className="field-label is-normal">
                                                <label className="label" htmlFor="amount">Pourcentage</label>
                                            </span>
                                            <span className="field-body">
                                                <span className="field">
                                                    <span className="control">
                                                        <input
                                                            className="input"
                                                            name="amount"
                                                            required
                                                            step="0.01"
                                                            type="number"
                                                            value={this.state.value}
                                                            onChange={e => this.handleInputChange(e)} />
                                                    </span>
                                                </span>
                                            </span>
                                        </p>
                                    </div>
                                </div>

                                <button className="button is-primary">Enregistrer</button>

                                {this.renderDeleteButton()}
                            </form>
                        </div>}
                        {this.state.activeTab === 'comment' && <div className="tab2">
                            <div className="columns is-desktop">
                                <div className="column">
                                    <p className="field">
                                        <span className="field is-horizontal">
                                            <span className="field-label is-normal">
                                                <label className="label">Commentaire</label>
                                            </span>
                                            <span className="field-body">
                                                <span className="field">
                                                    <span className="control">
                                                        <textarea className="textarea"
                                                            onChange={(e: React.ChangeEvent<HTMLTextAreaElement>): void => this.onCommentChange(e)}
                                                            value={this.state.comment}
                                                            rows={5} />
                                                    </span>
                                                </span>
                                            </span>
                                        </span>
                                    </p>
                                </div>
                            </div>
                            <div className="modalFoter">
                                {this.renderDeleteCommentButton()}
                                {this.rendeSaveCommentButton()}
                            </div>
                        </div>}
                    </div>
                </div>
            </Popup>
    }

    onCommentChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ comment: event.target.value });
    }

    private postComment() {
        this.props.onChange("account", {
            account: this.props.row.account,
            chapter: this.props.row.chapter,
            comment: this.state.comment,
            amount: this.state.value,
            isCommentEdited: true
        })
        this.setState({ edit: false })
    }

    private deleteComment() {
        this.props.onChange("account", {
            account: this.props.row.account,
            chapter: this.props.row.chapter,
            comment: null,
            amount: this.state.value,
            isCommentEdited: true
        })
        this.setState({ edit: false, comment: null })
    }
}

interface Props {
    row: Row;
    onChange(type: "account", data: Common.AccountChangeData): void;
}

interface State {
    edit: boolean;
    value: number;
    comment: string;
    activeTab: string;
    confirm: boolean;
    title: string;
    id: any;
}



// WEBPACK FOOTER //
// ./src/component/scenarii/detail/account-header.tsx